export enum OntologyType {
    ALARM = 'ALARM',
    ANALOGIC = 'ANALOGIC',
    CALL_NOTIFICATION = 'CALL-NOTIFICATION',
    EVENT = 'EVENT',
    TICKET = 'TICKET',
    TRANSACTION = 'TRANSACTION',
    AVAILABILITY = 'AVAILABILITY',
    STATION_STATE = 'STATE',
    UNKNOWN = 'UNKNOWN'
}